@if (bundleTemplate && servicePlan) {
  <div class="d-flex flex-column align-items-center justify-content-center mb-4">
    <span class="text-grey text-center">{{ priceDisplayByCurrency?.labels?.top || priceDisplay?.labels?.top }}</span>
    <div class="d-flex justify-content-center align-items-center">
      @if (priceDisplayByCurrency) {
        <div class="text-legacy-gold me-1 d-flex align-items-center">
          {{ priceDisplayByCurrency?.labels?.main?.currency }}
        </div>
        @if (cutPriceVisually(priceDisplayByCurrency?.labels?.main?.value); as mainLabel) {
          <div class="text-legacy-gold heading__regular--xxxl">{{ mainLabel[0] }}</div>

          @if (mainLabel.length > 1) {
            <div class="text-legacy-gold d-flex align-items-end mb-1">
              {{ mainLabel[1] }}
            </div>
          }
        }
      } @else {
        <div class="text-legacy-gold heading__regular--xxxl text-center" data-cy="priceUponRequest">
          @if (priceDisplay?.labels?.main) {
            {{ priceDisplay.labels.main }}
          } @else {
            @if (!isSapProduct) {
              {{ 'productDetails.priceUponRequest' | cxTranslate }}
            }
          }
        </div>
      }
      @if (!priceDisplayByCurrency && isSapProduct && priceDisplay?.priceNotAvailable) {
        <div class="body--l text-center" data-cy="priceNotAvailable">
          {{ 'productDetails.priceNotAvailable' | cxTranslate }}
        </div>
      }
      @if (tooltipVisible()) {
        <dcp-icon-button-tooltip [openOnClick]="true" placement="End">
          <ng-container [ngTemplateOutlet]="tooltipContent"></ng-container>
        </dcp-icon-button-tooltip>
      }
    </div>

    @for (sub of priceDisplayByCurrency?.labels?.subs || priceDisplay?.labels?.subs; let idx = $index; track idx) {
      <span [innerHTML]="sub" class="text-grey text-center"></span>
    }
  </div>

  <dcp-cta-form
    [bundleTemplate]="bundleTemplate"></dcp-cta-form>
  <div class="pb-5"></div>
}
<ng-template #tooltipContent>
  <dcp-partner-plans-and-pricing-tooltip [ratePlans]="ratePlans"></dcp-partner-plans-and-pricing-tooltip>
</ng-template>
